"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import {
  applyAppearance,
  getClientPaletteFallback,
  getClientThemeFallback,
  type ThemeMode,
} from "@/lib/theme";

export default function ThemeController() {
  const { data } = useSession();

  useEffect(() => {
    const pref = data?.user?.themePreference;
    const mode: ThemeMode =
      pref === "light" || pref === "dark" ? pref : getClientThemeFallback();
    // Signed out (or session still loading): the cookie the server used for first paint.
    const palette = data?.user?.palette ?? getClientPaletteFallback();
    applyAppearance(palette, mode);
  }, [data?.user?.themePreference, data?.user?.palette]);

  return null;
}
